import {ScrollView,Image} from 'react-native';
import {themeColorSet, ThemedPressable, ThemedText, ThemedView} from '@app/theme';
import InterestDueCard from './components/InterestDueCard';
import CreditInfoCard from './components/CreditInfoCard';
import LoanBenefits from './components/LoanBenefits';
import ShortFallCard from './components/ShortFallCard';
import InterestCalculatorCard from '../Dashboard/components/InterestCalculatorCard/InterestCalculatorCard';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { endpoints } from '@app/api/apis';
import axios from 'axios';
import { formatIndianCurrency, isEmptyObject } from '@app/utils/utility';
import DashboardHeader from '../Dashboard/components/Header/Header';
import AccountProfile from '../../../assets/Icons/Account_profile';

import { 
  updateCreditDetails,
  updateInterestDetails,
  updateUserProfile,
  updatePendingRequestDetails,
  updatePendingAccountRequest,
  updateLoanDetails,
  updateIsNotFirstDisbursal,
  updateShortfallData,
 } from '@app/store/slices/authSlice';
import LoanClosureCard from './components/LoanClosureCard';
import LoanClosure from '../../../assets/Icons/Foreclosure';
import LoanExpiryCard from './components/LoanExpiryCard';
import dayjs from 'dayjs';
import CarouselInfoCards from './components/CarouselInfoCards';
import CarouselActionCards from './components/CarouselActionCards';
import ClosureLoss from './components/ClosureLoss';
import ElevateHomeCard from './components/ElevateHomeCard';
import ElevateContinueCard from './components/ElevateContinueCard';
import LoanExpiredCard from './components/LoanExpiredCard';
import ElevateHeader from './components/ElevateHeader';
import { APPLICATION_STATUS, checkColor, CREDIT_STATUS, FORECLOSURE_STATUS, mandateReRegistrationFlag, trackEvent } from '@app/utils';
import { LENDER_ID } from '@app/types/regix';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { updatePhoneNumber } from '@app/store/slices/commonSlice';
import { CaretRight } from '@app/sharedComponents/Icons';
import TransactionIconUnfocused from '../../../assets/Icons/TransactionIconUnfocused';
import ROUTE from '@app/navigationApp/routes';


import LoanScreenShimmer from './components/ShimmerPlaceholder';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import Button from '@app/sharedComponents/Button/Button';
import ManageLimitIconUnfocused from '../../../assets/Icons/ManageLimitIconUnfocused';
import { updatePartnerParams } from '@app/store/slices/platformSlice';
import BajajPausedCard from '@app/sharedComponents/BajajPausedCard';
import PageLoader from '@app/sharedComponents/PageLoader/PageLoader';
import { useBankAndMandate, useCreditLoanServicingApplication } from '@app/hooks/useBankAndMandate';
import BankAndMandate, { MandateNotificationPill } from '../AccountDetails/Component/BankAndMandate';
import ElevateContinueCardTata from './components/ElevateContinueCardTata';
import ElevateHomeCardTata from './components/ElevateHomeCardTata';
var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime)

type ForeclosureDetails = {
  status?: string;
  // Add other properties as needed
};

const LMSDasboard = ({navigation}) => {
  const userDetails = useAppSelector((state) => state.auth.userDetails);
  const bankDetails = useAppSelector((state) => state.auth.userProfile?.bankDetails);
  const lendingPartnerId = userDetails?.linkedCredits[0]?.lendingPartnerId;  ;
  const creditInfo = useAppSelector((state) => state.auth.creditDetails);
  const interestDetails = useAppSelector((state) => state.auth.interestDetails);
  const pendingRequestDetails = useAppSelector((state) => state.auth.pendingRequestDetails);
  const pendingAccountRequest = useAppSelector((state) => state.auth.pendingAccountRequest);
  const {showMyAccountIcon, showDashboardBenefitsForYou, showVoltBottomNavBar,callData ,platform} = useAppSelector(state=>state.platformParams);
  const [isAccountInForeClosure, setIsAccountInForeClosure] = useState<ForeclosureDetails>({});
  const [elevateDetails, setElevateDetails] = useState({});
  const [switchAccountDetails, setSwitchAccountDetails] = useState({});
  const dispatch = useAppDispatch();
  const {isfromTDL} = useAppSelector(state => state.platformParams);
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const creditStatus =  userDetails?.linkedCredits[0]?.creditStatus 
  const isFromTata = LENDER_ID?.TATA?.toLowerCase() === creditInfo?.lendingPartnerId?.toLowerCase();
  const firebaseParams = useAppSelector((state) => state.firebaseParams);
  const { data: bankAndMandateData } = useBankAndMandate();
  const showShouldInProgressMandate = (
    bankAndMandateData === null || 
    bankAndMandateData?.creditMandateMapping?.isMandateSetup === false || 
    bankAndMandateData?.creditMandateMapping === null
  ) && (
    userDetails?.linkedCredits[0]?.creditStatus === CREDIT_STATUS.ACTIVE || 
    userDetails?.linkedCredits[0]?.creditStatus === CREDIT_STATUS.APPROVED_NOT_DISBURSED
  ) && (
    bankAndMandateData?.isMandateUpdateAllowed === true
  );
  const MANDATE_RE_REGISTER_FEATURE = mandateReRegistrationFlag(firebaseParams, userDetails?.user?.phoneNumber);

  const {enable_ToFu_Flag,enable_ToFu_Flag_test_numbers} = firebaseParams;
  
  const isLMSUser = useAppSelector(state => state.commonReducer.isLMSUser);
  const isBFLLoan = useAppSelector(state => state.commonReducer.isBFLLoan);

  const enableToFuFlag = (enable_ToFu_Flag === 'true' ||enable_ToFu_Flag_test_numbers?.includes(userDetails?.user?.phoneNumber)) ? true : false;
  const activeEnhancementApplication = userDetails?.activeEnhancementApplication;
  const manageLimitConfigForLender = userDetails?.manageLimitConfigForLender;


  const storeCreditId = userDetails?.linkedCredits[0]?.creditId
  const storeAccountId = userDetails?.linkedApplications[0]?.accountId

  const closeBottomSheet = () => {
    setIsBottomSheetVisible(false);
    AsyncStorage.setItem('isTdl', 'false');
  };

 const openTDLBottomSheet = async() => {
    const showTDLBS = await AsyncStorage.getItem('isTdl');
    if(showTDLBS === 'false'){
      return
    }
    setIsBottomSheetVisible(true);
  };

  useEffect(()=>{
    if(isfromTDL){
      openTDLBottomSheet();
    }
  },[])
      
  const getContactNumberForCall = (defaultNum:string) =>{
    if (platform === 'FREO') {
      return '+916364465607'
    } else if (platform === 'JUPITER') {
        return '+918655055086'
    } else {
        return defaultNum
    }
  }

  const checkForElevate = () =>{
    const url = endpoints.bookTransfer+ userDetails?.linkedApplications[0]?.accountId 
    axios.get(url)
    .then((res)=>{
      console.log('bookTransfer',res.data);
      setElevateDetails(res.data)
    }).catch((err)=>{ 
      console.log('bookTransfer',err
      )
    })
  }

  const checkForAccountSwitch = () =>{
    const url = endpoints.switchCredit+'/allowed/'+ userDetails?.linkedApplications[0]?.accountId 
    axios.get(url,{handleFromMF : true})
    .then((res)=>{
      console.log('checkForAccountSwitch',res.data);
      setSwitchAccountDetails(res.data)
    }).catch((err)=>{ 
      console.log('bookTransfer',err
      )
    })
  }

  const fetchCreditDetails = ()=>{
    setIsLoading(true);
    const url = endpoints.creditInfo + userDetails?.linkedCredits[0]?.creditId       
    axios.get(url).then((res)=>{
      dispatch(updateCreditDetails(res?.data ?? {}));
    }).catch((err)=>{
      console.log('creditInfo',err)
    }).finally(() => {
      // for showing shimmer placeholder for 0.5 seconds
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    });
  }

  const fetchInterestDetails = ()=>{
    const url = endpoints.interestDetails + userDetails?.linkedCredits[0]?.creditId   
    axios.get(url).then((res)=>{
      const obj={
        "totalAmount": 6171.82,
        "outstandingInterest": 4439.00,
        "month": "Mar",
        "year": "2025",
        "autoPayDate": 1743618600000,
        "isMandateSetup": true,
        "repaymentAllowed": true,
        "interestStatus": "AWAITING_MANDATE_STATUS",
        "outStandingCharges": 1732.82,
        sellOfDate: 15,
    }
      // dispatch(updateInterestDetails(obj))
      dispatch(updateInterestDetails(res?.data  ?? {}))
    }).catch((err)=>{
      dispatch(updateInterestDetails({}))
      console.log('fetchInterestDetails',err)
    })
  }

  const fetchPendingRequests = ()=>{
    const url = endpoints.pendingRequests + userDetails?.linkedCredits[0]?.creditId       
    axios.get(url).then((res)=>{
      dispatch(updatePendingRequestDetails(res?.data ?? {}))
    }).catch((err)=>{
      console.log('fetchPendingRequests',err)
    })
  }


  const fetchUserProfile = ()=>{
    const url = endpoints.userProfile + userDetails?.linkedApplications[0]?.accountId       
    axios.get(url).then((res)=>{
      dispatch(updateUserProfile(res?.data ?? {}))
    }).catch((err)=>{
      console.log('fetchUserProfile',err)
    })
  }


  const fetchForClosureStatus = () =>{
    if(userDetails?.linkedCredits[0]?.creditStatus !== 'PENDING_CLOSURE'){
      setIsAccountInForeClosure({})
      return
    }
    const url = endpoints.checkForClosureStatus + userDetails?.linkedCredits[0]?.creditId
    axios.get(url).then((res)=>{
      setIsAccountInForeClosure(res?.data ?? {})
    }
    ).catch((err)=>{
      console.log('fetchClosureRequest',err)
    }
    )
  }

  const fetchAccoountUpdateRequest = () =>{
    const url = endpoints.getPendingDetailsRequest + userDetails?.linkedApplications[0]?.accountId
    axios.get(url).then((res)=>{
      dispatch(updatePendingAccountRequest(res?.data ?? {}))
      // setPendingAccountRequest(res.data)
    }
    ).catch((err)=>{
      console.log('fetchAccoountUpdateRequest',err)
    }
    )
  }

  const fetchLoanDetails = () =>{
    const {creditStatus} = userDetails?.linkedCredits[0] || {};
    if(creditStatus === CREDIT_STATUS.APPROVED_NOT_DISBURSED || creditStatus === CREDIT_STATUS.ACTIVE){
      const url = endpoints.loanDetails + userDetails?.linkedCredits[0]?.creditId
      axios.get(url).then((res)=>{
        dispatch(updateLoanDetails(res?.data ?? {}))
      }).catch((err)=>{
        console.log('fetchLoanDetails',err)
      })
    }
    
  }

  const fetchDisbursalDetails = () => {
    const url = endpoints.disbursalDetails + userDetails?.linkedCredits[0]?.creditId
    axios.get(url)
    .then((res)=>{
        console.log('disbursal details',res.data)
        dispatch(updateIsNotFirstDisbursal({isNotFirstDisbursal :res?.data?.length>0}))
    }
    ).catch((err)=>{
        console.log('disbursal details',err)
    })
  }
  const [isLoading, setIsLoading] = useState(true);

  const loadDashboard = () => {
      fetchCreditDetails(),
      fetchInterestDetails(),
      fetchPendingRequests(),
      fetchForClosureStatus(),
      fetchUserProfile(),
      checkForElevate(),
      checkForAccountSwitch(),
      fetchAccoountUpdateRequest(),
      fetchLoanDetails(),
      fetchDisbursalDetails()
      if(!userDetails?.linkedCredits[0]?.isShortfallDue){
        dispatch(updateShortfallData({}))
      }
  };

  useEffect(()=>{
    if(storeAccountId && storeCreditId){
        dispatch(updatePartnerParams({showCall:true}))
        // Please review this Carefully. added use isFocused check to remove loadDashboard() from 
        // calling when we updated user context on another page
        loadDashboard();
    }
  dispatch(updatePhoneNumber({phoneNumber :'07949106901'}))
  },[storeAccountId , storeCreditId , isLMSUser, userDetails])

  const loanClosureNavigation = () => {
    if(userDetails?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ){
      const showOnlyVirtualAccountBajaj = firebaseParams?.show_only_virtual_account_bajaj === 'true' || firebaseParams?.show_only_virtual_account_bajaj_test_numbers?.includes(userDetails?.user?.phoneNumber);
      if(showOnlyVirtualAccountBajaj){
        navigation.navigate(ROUTE.OLD_FORECLOSURE)
      }else{
        AsyncStorage.setItem('isBajajClosure', 'true');
        navigation.navigate("MF_FETCH")
      }
    }else{
      navigation.navigate(ROUTE.HOW_TO_CLOSE_ACCOUNT)
    }
  }
  const renewalDate = dayjs(userDetails?.linkedCredits[0]?.renewalDate)
  const currentDate = dayjs()
  const daysToRenewal = renewalDate.isSame(currentDate, 'day') && renewalDate.isAfter(currentDate) ? 1 
    : renewalDate.startOf('day').diff(currentDate.startOf('day'), 'day') + 1;
  const isLoanExpired = renewalDate.isBefore(currentDate) ;
  const switchLender = switchAccountDetails?.creditDetailsList?.find((account)=>account.lenderId !== lendingPartnerId);
  const isLoanExpiringToday = dayjs(renewalDate).format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD');
  const foreClosureInprogress = (
    <>
    <LoanClosureCard foreclosureDetails={isAccountInForeClosure}/>
    {isAccountInForeClosure?.status === FORECLOSURE_STATUS.IN_REVIEW && <ClosureLoss/>}
    </>
  )




  if (isBFLLoan) {
    return (
      <>
      {isLoading ? (
        <PageLoader />
      ) : (
          <ThemedView flex={1} style={{ backgroundColor: themeColorSet['bg-surface-page'] }} >
          <DashboardHeader
            isfromTDL={isfromTDL}
            callDataVisible={true}
            navigation={navigation}
            showMyAccountIcon={showMyAccountIcon}
            name={userDetails?.user?.fullName?.split(' ')[0] ?? ''}
          />
          {switchAccountDetails?.isAllowed && <ElevateHeader accountId={userDetails?.linkedApplications[0]?.accountId} switchLender={switchLender} navigation={navigation}/>}
          <BajajPausedCard handleNavigate={() => {
            navigation.navigate('BAJAJ_SHUTDOWN')
            trackEvent('BFL_NOTICE_KNOW_MORE_BUTTON_CLICKED')
            }} />
          {elevateDetails?.isAllowed && elevateDetails?.isFirstTime && <ElevateHomeCard navigation={navigation} />}
          {elevateDetails?.isAllowed && !elevateDetails?.isFirstTime && <ElevateContinueCard navigation={navigation} elevateDetails={elevateDetails} />}
        </ThemedView>
      )}
      
      </>
    )
  }

    return(
        <>
          <ThemedView flex={1} style={{backgroundColor:themeColorSet['bg-surface-page']}} >
            <DashboardHeader
             isfromTDL={isfromTDL}
              callDataVisible={true}
              navigation={navigation}
              showMyAccountIcon={showMyAccountIcon}
              name={userDetails?.user?.fullName?.split(' ')[0] ?? ''}
            />
              {switchAccountDetails?.isAllowed && <ElevateHeader accountId={userDetails?.linkedApplications[0]?.accountId} switchLender={switchLender} navigation={navigation}/>}
              <ScrollView>
              {isLoading ? <LoanScreenShimmer/> : 
                <>
                  <ThemedView mb="2xs">
                    <CarouselActionCards navigation={navigation}/>
                    <CarouselInfoCards pendingRequestDetails={pendingRequestDetails} pendingAccountRequest={pendingAccountRequest} navigation={navigation}/>
                  </ThemedView>
                  {elevateDetails?.isAllowed && elevateDetails?.isFirstTime  && <ElevateHomeCardTata navigation={navigation}/>}
                  {elevateDetails?.isAllowed && !elevateDetails?.isFirstTime && <ElevateContinueCardTata navigation={navigation} elevateDetails={elevateDetails}/>}
                  {isLoanExpired && isEmptyObject(isAccountInForeClosure) && pendingRequestDetails?.renewalRequestDetailsList?.length<1 &&
                  <LoanExpiredCard creditInfo={creditInfo}  navigation={navigation} contactNumber={getContactNumberForCall(callData)}/>}
                </>
              }
              {creditStatus === 'PENDING_CLOSURE' && foreClosureInprogress}
              {(!isLoanExpired ||  pendingRequestDetails?.renewalRequestDetailsList?.length>0) && creditStatus !== 'PENDING_CLOSURE'   &&
              <>
                {
                  isLoading ? <LoanScreenShimmer/>  : 
                <>
                {userDetails?.linkedCredits[0]?.isShortfallDue  && <ShortFallCard navigation={navigation}/>}
                {!isEmptyObject(interestDetails) && interestDetails &&  <InterestDueCard bankDetails={bankDetails} isFromTata={isFromTata} interestDetails={interestDetails} navigation={navigation}/>}
                {MANDATE_RE_REGISTER_FEATURE && showShouldInProgressMandate ? <ThemedView paddingLeft='lg' paddingRight='lg' marginTop='lg'><BankAndMandate navigation={navigation} route={''} isNotification={true}/></ThemedView> : (<></>)}
                {daysToRenewal <= 30 && daysToRenewal >=0 && pendingRequestDetails?.renewalRequestDetailsList?.length<1 && <LoanExpiryCard creditInfo={creditInfo} daysToRenewal={daysToRenewal} navigation={navigation} />}
                {!isEmptyObject(creditInfo) && 
                  <CreditInfoCard isLoanExpiringToday={isLoanExpiringToday} 
                    lendingPartnerId={lendingPartnerId} 
                    creditInfo={creditInfo}
                    navigation={navigation} 
                    pendingRequestInfo={pendingRequestDetails} 
                    enableToFuFlag={enableToFuFlag} 
                    activeEnhancementApplication={activeEnhancementApplication}
                    manageLimitConfigForLender={manageLimitConfigForLender}
                  />
                }
                </>
                }
                <ThemedView my='lg'>
                  <InterestCalculatorCard navigation={navigation}/>
                </ThemedView>
                {!showVoltBottomNavBar &&
                <ThemedView padding='lg' backgroundColor='bg-surface-primary' borderColor='border-primary' borderTopWidth={1} borderBottomWidth={1} >
                  <ThemedText variant='h5s' color='text-primary'>Manage loan</ThemedText>
                  <ThemedView px="lg" mt="lg" backgroundColor='bg-surface-primary' borderRadius='lg' borderWidth={1} borderColor='border-primary' >

                  <ThemedPressable flexDirection='row' alignItems='center' justifyContent='space-between' py="xl" onPress={()=>navigation.navigate(ROUTE.ACCOUNT_DETAILS)}>
                    <ThemedView flexDirection='row'>
                      <AccountProfile size={24}  color={checkColor('#1434CB')}/>
                      <ThemedText variant='b3m' color='text-primary' ml="md">Account details</ThemedText>
                    </ThemedView>
                    <CaretRight color={themeColorSet['bg-action-primary']}  size={14}/>
                  </ThemedPressable>
                  <ThemedView height={1} width={'100%'} backgroundColor='border-primary' />
                  
                  <ThemedPressable flexDirection='row' alignItems='center' justifyContent='space-between' py="xl" onPress={()=>navigation.navigate(ROUTE.TRANSACTION_SCREEN)}>
                    <ThemedView flexDirection='row'>
                      <TransactionIconUnfocused color={checkColor('#1434CB')}/>
                      <ThemedText variant='b3m' color='text-primary' ml="md">Transaction history</ThemedText>
                    </ThemedView>
                    <CaretRight color={themeColorSet['bg-action-primary']}  size={14}/>
                  </ThemedPressable>
                  <ThemedView height={1} width={'100%'} backgroundColor='border-primary' />
                  <ThemedPressable flexDirection='row' alignItems='center' justifyContent='space-between' py="xl" onPress={()=>navigation.navigate(ROUTE.MANAGE_LIMIT_SCREEN)}>
                    <ThemedView flexDirection='row'>
                      <ManageLimitIconUnfocused color={checkColor("#1434CB")}/>

                      <ThemedText variant='b3m' color='text-primary' ml="md">Manage Limit</ThemedText>
                    </ThemedView>
                    <CaretRight color={themeColorSet['bg-action-primary']}  size={14}/>
                  </ThemedPressable>
                  <ThemedView height={1} width={'100%'} backgroundColor='border-primary' />
                  <ThemedPressable flexDirection='row' alignItems='center' justifyContent='space-between' py="xl" onPress={loanClosureNavigation}>
                    <ThemedView flexDirection='row'>
                      <LoanClosure size={24} color={checkColor("#1434CB")}/>
                      <ThemedText variant='b3m' color='text-primary' ml="md">Loan closure</ThemedText>
                    </ThemedView>
                    <CaretRight color={themeColorSet['bg-action-primary']}  size={14}/>
                  </ThemedPressable>
                  </ThemedView>

                </ThemedView>}
                
                <ThemedView mb="lg" mt="sm">
                {showDashboardBenefitsForYou && (showVoltBottomNavBar || isfromTDL) &&<LoanBenefits/>}
                </ThemedView>
              </>
                }
              </ScrollView>
            </ThemedView>
            <BottomSheetContainer
            isVisible={isBottomSheetVisible}
            close={closeBottomSheet}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            containsTextInput
            containerStyle={{ backgroundColor: '#fefefe' }}
        >
          <ThemedView p="lg" alignItems='center' justifyContent='center' >
        <Image style={{width: 300, height: 191}}
                       source={{uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/sdk_process_complete.png"}}/>
          <ThemedText variant='b3r' color="text-primary" mt="4xl" mb="sm">Congratulations!</ThemedText>
          <ThemedText variant='b3r' color="text-secondary" mb="2xl">You can now access up to ₹{formatIndianCurrency(creditInfo?.availableCreditAmount)}. Tap to withdraw your funds</ThemedText>
          <Button
            label="Withdraw"
            type="SOLID"
            size="MD"
            handlePress={() => {
              closeBottomSheet();
              navigation.navigate(ROUTE.WITHDRAW_AMOUNT, { creditInfo });
            }}
            overRideStyle={{ marginTop: 16 }}
          />
          </ThemedView>

        </BottomSheetContainer>
        </>
    )
}

export default LMSDasboard;